var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResponsibility = function SvgResponsibility(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#responsibility_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45.405,
    height: 15.135,
    y: 46.054,
    fill: "#2F68D1",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.378,
    height: 15.135,
    x: 32.162,
    y: 27.135,
    fill: "#6C9BF1",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 28.378,
    height: 15.135,
    x: 22.703,
    y: 8.216,
    fill: "#B4CFFF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.027,
    height: 15.135,
    x: 11.351,
    y: 27.135,
    fill: "#FFD2A8",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.811,
    height: 15.135,
    x: 49.189,
    y: 46.054,
    fill: "#FF9D43",
    rx: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "responsibility_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgResponsibility;